import templateUrl from 'emun.customer/customer-campaigns.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import ServiceBus from 'servicestack/service-bus'

class CustomerCampaignsController {
    constructor($rootScope) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();

		$ctrl.bus.send('GetAllCampaigns.json').then(res => {
			$ctrl.campaigns = res.data;
		});
	}
	showContent(campaign) {
		let $ctrl = this;
		window.open(campaign.longArchiveUrl, 'Campaign Content');
	}
}

let CustomerCampaigns = {
    bindings: {
        id: '@',
        customerId: '@',
        retailerId: '@',
		customer: '<',
		contactId: '@'
    },
	controller: CustomerCampaignsController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl
	}
}

export default CustomerCampaigns